import { withRouter } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NoAccessWithRedirect = ({
  history,
  illustration = 'keys',
  message,
  title
}) => /*#__PURE__*/_jsxs(UIErrorMessage, {
  illustration: illustration,
  title: title,
  type: "403",
  children: [/*#__PURE__*/_jsx("p", {
    children: message
  }), /*#__PURE__*/_jsx(UIButton, {
    use: "tertiary-light",
    onClick: () => history.push('/'),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "noAccess.redirect"
    })
  })]
});
export default withRouter(NoAccessWithRedirect);